import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Image from "next/image";
import Link from "next/link";
import NavLink from "./NavLink";

/**
 * 导航菜单
 * @param title 标题
 * @param type 类型 0-有下拉菜单 1-无下拉菜单
 * @param url 跳转链接
 * @returns 导航菜单组件
 */
const NavMenu = ({
  title,
  type = 0,
  url,
}: {
  title: string;
  type?: number;
  url: string;
}) => {
  const { pathname } = useRouter();
  const { t } = useTranslation();

  // about dropdown menus
  const aboutMenus = [
    {
      url: "/about",
      text: "menu.about",
    },
    {
      url: "/about/exchange",
      text: "menu.harvest_dream_value",
    },
  ];

  const discountMenus = [
    {
      url: "/discount",
      text: "menu.new_account_discount",
    },
    {
      url: "/prediction",
      text: "menu.worldcup_prediction",
    },
  ];

  return (
    <div
      className={`group flex h-full items-center px-4`}
    >
      <NavLink title={title} type={type} url={url} pathname={pathname} />

      {type === 0 && url === "/about" && (
        <div
          className="absolute left-0 top-[86px] z-10 hidden w-full justify-center bg-white py-8 group-hover:flex"
          style={{ boxShadow: "0 10px 26px 0 rgba(45, 45, 45, 0.08)" }}
        >
          <div className="flex w-container justify-between">
            <div className="flex text-base text-stone-800">
              <div className="mr-20 flex w-[300px] flex-col border-r border-gray-600 pr-10 ">
                <div className="mb-5 text-2xl font-semibold">
                  {t("menu.about")}
                </div>
                <div className="">{t("menu.about_desc")}</div>
              </div>
              <div className="grid grid-flow-row grid-cols-2 grid-rows-[24px] gap-x-20 gap-y-4 ">
                {aboutMenus.map((menu, index) => (
                  <Link
                    className="text-stone-500 hover:text-primary transition-colors duration-200"
                    href={menu.url}
                    key={index}
                    data-qt="header_submenu_click"
                    data-qt-nav-url={menu.url}
                  >
                    {t(menu.text)}
                  </Link>
                ))}
              </div>
            </div>
            <Image
              src="/images/gift.webp"
              title="header"
              alt="header"
              width={292}
              height={225}
            />
          </div>
        </div>
      )}

      {type === 0 && url === "/discount" && (
        <div
          className="absolute left-0 top-[86px] z-10 hidden w-full justify-center bg-white py-8 group-hover:flex"
          style={{ boxShadow: "0 10px 26px 0 rgba(45, 45, 45, 0.08)" }}
        >
          <div className="flex w-container justify-between">
            <div className="flex text-base text-stone-800">
              <div className="mr-20 flex w-[300px] flex-col border-r border-gray-600 pr-10 ">
                <div className="mb-5 text-2xl font-semibold">
                  {t("menu.discounts_activities")}
                </div>
                <div className="">{t("menu.discount_desc")}</div>
              </div>
              <div className="grid grid-flow-row grid-cols-2 grid-rows-[24px] gap-x-4 gap-y-4 ">
                {discountMenus.map((menu, index) => (
                  <Link
                    className="text-stone-500 hover:text-primary transition-colors duration-200"
                    href={menu.url}
                    key={index}
                    data-qt="header_submenu_click"
                    data-qt-nav-url={menu.url}
                  >
                    {t(menu.text)}
                  </Link>
                ))}
              </div>
            </div>
            <Image
              src="/images/gift.webp"
              title="header"
              alt="header"
              width={292}
              height={225}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default NavMenu;
